import { render, staticRenderFns } from "./PopularCreate.vue?vue&type=template&id=beb61100&scoped=true&"
import script from "./PopularCreate.vue?vue&type=script&lang=js&"
export * from "./PopularCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb61100",
  null
  
)

export default component.exports